var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auctionCoverImg)?_c('div',{staticClass:"ta-auction-view-cover"},[_c('img',{attrs:{"src":_vm.auctionCoverImg}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }